import styles from "./style.module.scss";
import Link from "@components/shared/linkNoPrefetch";
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import {
    ICategoryPageSharedProps,
    IOfferPageSharedProps,
} from "@genericTypes/sharedTypes";

export default function ContentTab({
    contentTab,
    defaultLink,
}: {
    contentTab: {
        link: string;
        label: string;
        slug: string;
    }[];
    defaultLink?: boolean;
}) {
    const { data } = useQuery<ICategoryPageSharedProps>([
        "categoryPageSharedProps",
    ]);
    const { data: offerSharedProps } = useQuery<IOfferPageSharedProps>([
        "offerPageSharedProps",
    ]);
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { activeTab } = data
        ? data
        : offerSharedProps
        ? offerSharedProps
        : {};

    useEffect(() => {
        const activatedElement =
            document?.getElementsByClassName("activatedElement")?.[0];
        if (activatedElement) {
            const containerElement = document.getElementById("scrollElement");
            const paddingPageShift = 20;
            const positionToShift =
                activatedElement.getBoundingClientRect().left -
                paddingPageShift;
            if (containerElement) {
                containerElement.scrollTo({
                    left: positionToShift,
                    behavior: "smooth",
                });
            }
        }
    }, []);
    return (
        <section className={`${styles["mainContainer"]}`}>
            <div className={`${styles["shadowStyle"]}`}></div>
            <div
                className={`${styles["scrollBarStyle"]} flex lg:gap-20 gap-7  overflow-x-auto `}
                id="scrollElement"
            >
                {contentTab?.map((el, index) => {
                    if (defaultLink) {
                        return (
                            <a
                                key={index}
                                href={el.link}
                                className={`${
                                    styles["oneLink"]
                                }  lg:text-xl text-xs text-center lg:min-h-[55px] py-3 px-1 ${
                                    index > 0 ? "ml-10" : ""
                                } min-w-[84px] ${
                                    el.slug === activeTab
                                        ? `${styles["activeStyle"]} activatedElement `
                                        : ""
                                }`}
                            >
                                {el.label}
                            </a>
                        );
                    }
                    return (
                        <Link
                            key={index}
                            href={el.link}
                            className={`${
                                styles["oneLink"]
                            } transition lg:text-xl text-xs text-center lg:min-h-[55px] py-3 px-1 ${
                                index > 0 ? "ml-10" : ""
                            } min-w-[84px] ${
                                el.slug === activeTab
                                    ? `${styles["activeStyle"]} activatedElement`
                                    : ""
                            }`}
                        >
                            {el.label}
                        </Link>
                    );
                })}
            </div>
        </section>
    );
}
